import PropTypes from 'prop-types'
import React from 'react'
import Button from './Button'

const Preview = ({
  disabled, onTogglePreview, previewProps, previewComponent, showPreview
}) => {
  const params = { router: {}, ...previewProps }
  const PreviewComponent = previewComponent
  return showPreview ? (
    <div className="preview">

      <Button
        className="btn btn-default pull-right preview-toggler"
        onClick={onTogglePreview}
        disabled={disabled}
      >
        Vorschau schließen
      </Button>

      <div className="content">
        <PreviewComponent {...params} />
      </div>
    </div>
  ) : null
}

Preview.propTypes = {
  disabled: PropTypes.bool,
  onTogglePreview: PropTypes.func.isRequired,
  previewComponent: PropTypes.func.isRequired,
  previewProps: PropTypes.object.isRequired,
  showPreview: PropTypes.bool.isRequired,
}

export { Preview as default }



// WEBPACK FOOTER //
// ./src/shared/components/Preview.js